<template>
	<basic-layout id="copy-right-claim-1">
		<template #content>
			<v-layout column mt-4>
				<v-flex mb-4>
					<h1 class="mb-3">Copyright Claim</h1>
				</v-flex>
			</v-layout>
			<v-layout class="pb-12">
				<v-flex>
					<claim-title>What is your claim? *</claim-title>
					<v-layout wrap>
						<v-flex xs12 md6>
							<v-select :items="claimItems" v-model="claimType"></v-select>
						</v-flex>
						<v-flex class="pl-md-8">
							<v-text-field
								v-if="claimType === 3"
								label="Please add information about your issue *"
								v-model="otherClaimType"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout class="pb-12">
				<v-flex>
					<claim-title>Link to the content *</claim-title>
					<p class="caption font-weight-light text--secondary mt-0">(Please select correct claim type)</p>
					<v-layout v-for="i in noOfFilters" :key="i">
						<v-flex xs4 md2 class="mr-5 mt-2">
							<v-autocomplete
								data-cy="claim-type"
								:items="linkTypes"
								item-text="name"
								item-value="value"
								v-model="linkType[i - 1].type"
								label="Copyright claim type"
							>
							</v-autocomplete>
						</v-flex>
						<v-flex xs8 class="mr-5">
							<v-combobox
								data-cy="content-link"
								multiple
								v-model="linkType[i - 1].value"
								label="Add links"
								hint="Press Enter to insert more than 1 link"
								append-icon
								chips
								deletable-chips
								:disabled="!linkType[i - 1].type"
								@change="buldUploadLinks(i)"
							></v-combobox>
						</v-flex>
						<v-flex xs1 v-if="i != 1" class="mt-8">
							<v-btn icon>
								<v-icon medium @click="removeFilter(i - 1)">close</v-icon>
							</v-btn>
						</v-flex>
						<v-flex xs1 v-else>
							<v-btn xs-1 class="mt-4 ml-5" color="primary" fab small dark @click="addFilter">
								<v-icon :style="{ color: '#fff' }">add</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
					<v-flex data-cy="error" xs12 v-if="linkErrors.length" class="red--text caption">
						{{ linkErrors }}
					</v-flex>
				</v-flex>
			</v-layout>
			<v-layout class="pb-12">
				<v-flex>
					<claim-title>Who is affected? *</claim-title>
					<v-layout wrap>
						<v-flex xs12 md6>
							<v-select :items="affectedWho" v-model="affectedPerson"></v-select>
						</v-flex>
						<v-flex class="pl-md-8">
							<v-text-field
								v-if="affectedPerson === 3 || affectedPerson === 4"
								label="Please add information about the affectee *"
								v-model="otherAffectedPerson"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout column class="pb-4">
				<v-flex>
					<h3 class="font-weight-medium mb-3">How does it affect them? *</h3>
				</v-flex>
				<v-flex>
					<claim-title>It’s an unauthorised use of:</claim-title>
					<v-layout wrap>
						<v-flex xs12 md6>
							<v-select :items="unauthorisedUseReasons" v-model="unauthorisedUseReason"></v-select>
						</v-flex>
						<v-flex class="pl-md-8">
							<v-text-field
								v-if="unauthorisedUseReason === 7"
								label="Please add more information about unautorised use *"
								v-model="otherUnauthorisedUseReason"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout column class="pb-4">
				<v-flex>
					<claim-title>It hampers the right holder’s ability to:</claim-title>
					<v-layout wrap>
						<v-flex xs12 md6>
							<v-select :items="abilityHamperReasons" v-model="abilityHamperReason"></v-select>
						</v-flex>
						<v-flex class="pl-md-8">
							<v-text-field
								v-if="abilityHamperReason === 6"
								label="Please add more information *"
								v-model="otherAbilityHamperReason"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout column class="pb-12">
				<v-flex>
					<claim-title>How else does this amount to infringement ?</claim-title>
					<v-layout>
						<v-flex xs12 md6>
							<v-text-field
								label="Please add more information"
								v-model="otherInfringementReason"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout column class="pb-12">
				<v-flex>
					<claim-title>Who are you?</claim-title>
				</v-flex>
				<v-flex>
					<v-layout>
						<v-flex xs12 md6>
							<v-text-field
								data-cy="org-name"
								label="You/ Your organisation name *"
								v-model="orgName"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex>
					<v-layout>
						<v-flex xs12 md6>
							<v-text-field label="Your designation" v-model="designation"></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex>
					<v-layout>
						<v-flex xs12 md6>
							<v-text-field label="On behalf of" v-model="onBehalfOf"></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex>
					<v-layout wrap>
						<v-flex xs12 md6>
							<v-select
								data-cy="relation-with-owner"
								label="Relationship with copyright owner *"
								:items="relationWithOwners"
								v-model="relationWithOwner"
							></v-select>
						</v-flex>
						<v-flex class="pl-md-8">
							<v-text-field
								v-if="relationWithOwner === 2"
								label="Your relationship with owner *"
								v-model="otherRelationWithOwner"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout column class="pb-12">
				<v-flex>
					<claim-title
						>Proof of relationship – contract / letter of authorisation / power of attorney etc</claim-title
					>
					<v-layout>
						<media-preview
							:multiple="true"
							@change="onFileChange($event, 'relationProofs')"
							ref="relationProofs"
						/>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout class="pb-2" wrap>
				<v-flex xs12 md6>
					<v-text-field data-cy="email" label="Email *" v-model="email"></v-text-field>
				</v-flex>
				<v-flex xs12 md6 class="pl-md-8">
					<v-text-field label="Phone" v-model="phone"></v-text-field>
				</v-flex>
				<v-flex xs12 md6>
					<v-text-field data-cy="personal-name" label="Personal Name *" v-model="personalName"></v-text-field>
				</v-flex>
				<v-flex xs12 md6 class="pl-md-8">
					<v-text-field data-cy="address" label="Address *" v-model="address"></v-text-field>
				</v-flex>
				<v-flex xs12 md6>
					<v-text-field label="Landmark" v-model="landmark"></v-text-field>
				</v-flex>
				<v-flex xs12 md6 class="pl-md-8">
					<v-text-field data-cy="city" label="City *" v-model="city"></v-text-field>
				</v-flex>
				<v-flex xs12 md6>
					<v-text-field data-cy="pincode" label="Pincode *" v-model="pin"></v-text-field>
				</v-flex>
				<v-flex xs12 md6 class="pl-md-8">
					<v-text-field data-cy="country" label="Country *" v-model="country"></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout column class="pb-12">
				<v-flex>
					<claim-title>Verification (signature) (max 20mb) *</claim-title>
					<v-layout>
						<media-preview
							data-cy="upload-signature"
							@change="onFileChange($event, 'signature')"
							ref="signature"
						/>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout column class="pb-12">
				<v-flex>
					<claim-title>Any other details for upload</claim-title>
					<v-layout>
						<media-preview :multiple="true" @change="onFileChange($event, 'otherFiles')" ref="otherFiles" />
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout column class="pb-12">
				<v-flex>
					<claim-title>By submitting this complaint I hereby certify that:</claim-title>
					<v-layout column>
						<ul>
							<v-flex v-for="(item, i) in herebyCertifyPoints" :key="i" class="pl-2 pb-2">
								<li>{{ item }}</li>
							</v-flex>
						</ul>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout column class="pb-12">
				<vue-recaptcha
					data-cy="recaptcha"
					class="mb-3"
					ref="recaptcha"
					:sitekey="siteKey"
					type="checkbox"
					@verify="verifyUser"
					@expired="onExpired"
					:loadRecaptchaScript="true"
				/>
			</v-layout>
			<v-layout column class="pb-12">
				<v-btn
					data-cy="submit-btn"
					@click="onSubmitClick"
					color="primary"
					class="white--text"
					:loading="loading"
					:disabled="disabled"
					>Submit</v-btn
				>
			</v-layout>
		</template>
	</basic-layout>
</template>

<script>
import BasicLayout from "@/components/basic-layout";
import MediaPreview from "@/components/media-preview";
import VueRecaptcha from "vue-recaptcha";
import ClaimTitle from "@/components/claim-title";

import config from "@/config";
import { findErrorInMojTakatakLink } from "@/utils";

const initialData = {
	links: [],
	claimType: 1,
	otherClaimType: "",
	affectedPerson: 1,
	otherAffectedPerson: "",
	unauthorisedUseReason: 1,
	otherUnauthorisedUseReason: "",
	abilityHamperReason: 1,
	otherAbilityHamperReason: "",
	otherInfringementReason: "",
	orgName: "",
	designation: "",
	relationWithOwner: null,
	otherRelationWithOwner: "",
	email: "",
	phone: "",
	personalName: "",
	address: "",
	landmark: "",
	city: "",
	pin: "",
	country: "",
	captcha: null,
	linkTypes: [
		{
			name: "Video",
			value: "video"
		},
		{
			name: "Audio",
			value: "audio"
		},
		{
			name: "Both",
			value: "both"
		}
	],
	noOfFilters: 1,
	linkType: [{ type: "", value: [] }],
	onBehalfOf: "",
	herebyCertifyPoints: [
		"I have a good faith belief that this complaint is true and correct and that I have taken all reasonable measures to verify my claim",
		"The complaint is valid in law and does not meet any of the exceptions set out under Indian law",
		"I have the power and authority to make this claim",
		"My statements are correct",
		"The claims made under this complaint are not frivolous in nature and do not cause harassment to any individual/organisation"
	]
};
export default {
	components: {
		MediaPreview,
		BasicLayout,
		ClaimTitle,
		VueRecaptcha
	},
	data: () => ({
		siteKey: config.RECAPTCHA_SITE_KEY,
		claimItems: [
			{
				text: "This is an unauthorised use of my name/image/trademark",
				value: 1
			},
			{ text: "This is a copyright/trademark infringement", value: 2 },
			{ text: "Other legal issue", value: 3 }
		],
		affectedWho: [
			{ text: "Me", value: 1 },
			{
				text: "My company, organisation, client (if you are a lawyer/agent/representative)",
				value: 2
			},
			{ text: "Another copyright owner", value: 3 },
			{ text: "Other", value: 4 }
		],
		unauthorisedUseReasons: [
			{ text: "A trademark/name", value: 1 },
			{ text: "Art, literary work", value: 2 },
			{ text: "Video/audio/sound recording", value: 3 },
			{
				text: "A social media post made on ShareChat on another platform",
				value: 4
			},
			{ text: "A recording of a live performance", value: 5 },
			{ text: "Software", value: 6 },
			{ text: "Other", value: 7 }
		],
		abilityHamperReasons: [
			{
				text: "Reproduce in any material form including the storing of it by electronic means",
				value: 1
			},
			{ text: "Make copies to the public", value: 2 },
			{
				text: "Perform in public, or communicate to the public",
				value: 3
			},
			{ text: "Record/translate/adapt the work", value: 4 },
			{ text: "Sell, rent the work", value: 5 },
			{ text: "Other", value: 6 }
		],
		relationWithOwners: [{ text: "Me", value: 1 }, { text: "Other", value: 2 }],
		loading: false,
		files: {},
		...initialData
	}),
	computed: {
		linkErrors() {
			return this.linkType.reduce((acc, link) => {
				const error = findErrorInMojTakatakLink(link.value);
				if (error) {
					return [...acc, error];
				}
				return acc;
			}, []);
		},
		audioUploadData(state) {
			return state.media[this.audioKey] || {};
		},
		disabled() {
			if (this.claimType === 3 && !this.otherClaimType.trim()) {
				return true;
			}

			if (this.linkType) {
				if (this.linkType.filter(item => item.value.length).length === 0) return true;
			}

			if (this.linkErrors.length) {
				return true;
			}

			if ((this.affectedPerson === 3 || this.affectedPerson === 4) && !this.otherAffectedPerson.trim()) {
				return true;
			}
			if (this.unauthorisedUseReason === 7 && !this.otherUnauthorisedUseReason.trim()) {
				return true;
			}
			if (this.abilityHamperReason === 6 && !this.otherAbilityHamperReason.trim()) {
				return true;
			}
			if (!this.relationWithOwner) {
				return true;
			}
			if (this.relationWithOwner === 2 && !this.otherRelationWithOwner.trim()) {
				return true;
			}

			if (this.files && !(this.files.signature || []).length) {
				return true;
			}

			return !(
				this.orgName.trim() &&
				this.email.trim() &&
				this.pin.trim() &&
				this.address.trim() &&
				this.city.trim() &&
				this.country.trim() &&
				this.personalName.trim() &&
				!!this.captcha
			);
		}
	},
	methods: {
		onFileChange(files, key) {
			this.files = {
				...this.files,
				[key]: files
			};
		},
		getKeyWithOtherValue(allValues, value, otherNumbers, otherValue) {
			const text = allValues.find(valueObj => valueObj.value === value).text;
			return otherNumbers.includes(value) ? `${text} ${otherValue}` : text;
		},
		onSubmitClick() {
			this.loading = true;
			this.doUpload()
				.then(urlMap => {
					return urlMap.reduce((acc, [key, filename]) => {
						acc[key] = [...(acc[key] || []), filename];
						return acc;
					}, {});
				})
				.then(data => {
					this.links = [];
					this.linkType.map(i => {
						i.value.map(url => {
							this.links.push({ type: i.type, link: url });
						});
					});
					const payload = {
						links: this.links,
						claimType: this.getKeyWithOtherValue(this.claimItems, this.claimType, [3], this.otherClaimType),
						affectedPerson: this.getKeyWithOtherValue(
							this.affectedWho,
							this.affectedPerson,
							[3, 4],
							this.otherAffectedPerson
						),
						unauthorisedUseReason: this.getKeyWithOtherValue(
							this.unauthorisedUseReasons,
							this.unauthorisedUseReason,
							[7],
							this.otherUnauthorisedUseReason
						),
						abilityHamperReason: this.getKeyWithOtherValue(
							this.abilityHamperReasons,
							this.abilityHamperReason,
							[6],
							this.otherAbilityHamperReason
						),
						otherInfringementReason: this.otherInfringementReason,
						orgName: this.orgName,
						designation: this.designation,
						relationWithOwner: this.getKeyWithOtherValue(
							this.relationWithOwners,
							this.relationWithOwner,
							[2],
							this.otherRelationWithOwner
						),
						email: this.email,
						phone: this.phone,
						personalName: this.personalName,
						address: this.address,
						landmark: this.landmark,
						city: this.city,
						pin: this.pin,
						country: this.country,
						captcha: this.captcha,
						...data,
						signature: data.signature[0],
						onBehalf: this.onBehalfOf
					};
					return this.submitCopyRightClaim(this.removeEmpty(payload));
				})
				.then(() => {
					Object.assign(this, initialData);
					this.files = {};
					this.$refs["relationProofs"].files = [];
					this.$refs["signature"].files = [];
					this.$refs["otherFiles"].files = [];
					this.links = [];
					this.linkType = [{ type: "", value: [] }];
				})
				.catch(err => {
					console.error(err);
				})
				.then(() => {
					this.resetRecaptcha();
					this.loading = false;
				});
		},
		submitCopyRightClaim(payload) {
			return this.$store.dispatch("SUBMIT_COPYRIGHT_CLAIM", payload);
		},
		removeEmpty(payload) {
			return Object.keys(payload).reduce((acc, curr) => {
				let value = payload[curr];
				if ((Array.isArray(value) && value.length === 0) || !value) {
					return acc;
				}
				return {
					...acc,
					[curr]: payload[curr]
				};
			}, {});
		},
		uploadMedia(file) {
			let formData = new FormData();
			formData.append("file", file);
			return this.$store.dispatch("UPLOAD_MEDIA", formData);
		},

		doUpload() {
			const uploads = [];
			const keys = Object.keys(this.files);

			keys.forEach(key => {
				(this.files[key] || []).forEach(file => {
					uploads.push([key, file]);
				});
			});
			return Promise.all(
				uploads.map(([key, file]) => this.uploadMedia(file).then(({ filename }) => [key, filename]))
			);
		},
		verifyUser(payload) {
			this.captcha = payload;
		},
		onExpired() {
			this.resetRecaptcha();
		},
		resetRecaptcha() {
			this.$refs.recaptcha.reset();
			this.captcha = null;
		},
		addFilter() {
			if (this.noOfFilters > 2) {
				alert("MAX 3 Filters Allowed");
			} else {
				let conditionsObj = { type: "", value: [] };
				this.linkType.push(conditionsObj);
				this.noOfFilters++;
			}
		},
		removeFilter(indexToBeRemoved) {
			this.linkType.splice(indexToBeRemoved, 1);
			this.noOfFilters--;
		},
		buldUploadLinks(i) {
			const hasSpacesOrCommas = this.linkType[i - 1].value.some(link => link.match(/,|\s/));
			if (hasSpacesOrCommas) {
				const links = [
					...new Set(
						this.linkType[i - 1].value.reduce((acc, link) => {
							const newLinks = link.split(/,|\s+/).filter(link => Boolean(link.trim()));
							return [...acc, ...newLinks];
						}, [])
					)
				];
				this.linkType[i - 1].value = links;
				this.linkType = [...this.linkType];
			}
		}
	}
};
</script>
